<template>
  <div class="p-4 bg-white">
    <b-form @submit.prevent="onSubmit">
      <!-- Tabs -->
      <b-row class="mb-5">
        <b-col :md="12">
          <CustomNav :items="tabs" @item-click="(tab) => (activeTab = tab)" />
        </b-col>
      </b-row>

      <b-row v-show="activeTab == 'general'">
        <!-- LEFT COLUMN -->
        <b-col :md="isFormShippment ? 12 : 6">
          <!-- Account Info -->
          <section>
            <div class="section-title">
              <h6>COMPANY INFO</h6>
            </div>
            <b-row>
              <b-col md="12">
                <b-form-group label="Company Name *">
                  <template #label>
                    <div>
                      Company Name
                      <span class="text-red">*</span>
                    </div>
                  </template>
                  <b-form-input
                    v-model="form.accountName"
                    plain
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Customer Status *">
                  <template #label>
                    <div>
                      Customer Status
                      <span class="text-red">*</span>
                    </div>
                  </template>
                  <b-form-select
                    required
                    v-model="form.cutomerStatus"
                    :options="cutomerStatusOptions"
                    plain
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Customer Class *">
                  <template #label>
                    <div>
                      Customer Class
                      <span class="text-red">*</span>
                    </div>
                  </template>
                  <b-form-select
                    plain
                    v-model="form.cutomerClass"
                    :options="cutomerClassOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <!-- Account Address -->
          <section class="mb-4">
            <!-- <div class="section-title">
              <h6>ACCOUNT ADDRESS</h6>
            </div> -->
            <b-row>
              <b-col md="6">
                <b-form-group label="Country *">
                  <template #label>
                    <div>
                      Country
                      <span class="text-red">*</span>
                    </div>
                  </template>
                  <v-select
                    v-model="form.country"
                    :options="countryOptions"
                    placeholder="Select Country"
                    label="text"
                    :reduce="(option) => option.value"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" v-if="form.country == 'ID'">
                <b-form-group label="Province *">
                  <template #label>
                    <div>
                      Province
                      <span class="text-red">*</span>
                    </div>
                  </template>
                  <v-select
                    :options="option.provience"
                    required
                    label="name"
                    :reduce="(val) => val.id"
                    plain
                    v-model="form.province"
                    @input="onProvinceChange"
                    placeholder="Select Province"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <template v-if="form.country == 'ID'">
              <b-row>
                <b-col md="6">
                  <b-form-group label="City *">
                    <template #label>
                      <div>
                        City
                        <span class="text-red">*</span>
                      </div>
                    </template>
                    <v-select
                      label="name"
                      :reduce="(val) => val.id"
                      :options="option.cities"
                      required
                      v-model="form.city"
                      @input="onCityChange"
                      placeholder="Select City"
                      :disabled="!form.province"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="District *">
                    <template #label>
                      <div>
                        District
                        <span class="text-red">*</span>
                      </div>
                    </template>
                    <v-select
                      label="name"
                      :reduce="(val) => val.id"
                      v-model="form.district"
                      required
                      :options="option.districts"
                      @input="onDistrictChange"
                      placeholder="Select District"
                      :disabled="!form.city"
                    ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group label="Sub District">
                    <v-select
                      label="name"
                      :reduce="(val) => val.id"
                      v-model="form.subDistrict"
                      :options="option.villages"
                      placeholder="Select Sub District"
                      :disabled="!form.district"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Postal Code">
                    <b-form-input
                      type="number"
                      v-model="form.postalCode"
                      placeholder="Select Postal Code"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>

            <b-form-group label="Address">
              <b-form-textarea
                v-model="form.address"
                rows="2"
              ></b-form-textarea>
            </b-form-group>
          </section>
        </b-col>

        <!-- RIGHT COLUMN -->
        <b-col :md="isFormShippment ? 12 : 6">
          <!-- Additional Account Info -->
          <section class="mb-4">
            <div class="section-title">
              <h6>ADDITIONAL INFO</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Logo">
                  <b-form-file
                    v-model="form.logo"
                    browse-text="Browse"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Web">
                  <b-form-input v-model="form.web" @input="onWebChange"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Fax">
                  <b-form-input v-model="form.fax" type="number"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Assistance">
                  <b-form-input v-model="form.assistance"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <!-- Additional Contact -->
          <section class="mb-4">
            <div class="section-title">
              <h6>ADDITIONAL CONTACT</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Name">
                  <b-form-input v-model="form.picName"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Job Title">
                  <b-form-input v-model="form.picJobTitle"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Email Office">
                  <b-form-input v-model="form.emailOffice"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Email">
                  <b-form-input v-model="form.email"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Phone">
                  <b-form-input v-model="form.phone"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Mobile Phone">
                  <b-form-input v-model="form.mobile"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
        </b-col>
      </b-row>

      <b-row v-show="activeTab == 'billing'">
        <b-col md="6">
          <!-- Account Address -->
          <section class="mb-4">
            <div class="section-title">
              <h6>BILL TO ADDRESS</h6>
            </div>
            <!-- Same as General Address Toggle -->
            <b-row class="mb-3">
              <b-col md="12">
                <b-form-checkbox
                  v-model="sameAsGeneralAddress"
                  @change="onSameAsGeneralChange"
                  class="custom-checkbox"
                >
                  <span>Copy With General Address</span>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <div>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Country *">
                    <v-select
                      v-model="form.countryBill"
                      :options="countryOptions"
                      placeholder="Select Country"
                      label="text"
                      :reduce="(option) => option.value"
                      :clearable="false"
                      :disabled="sameAsGeneralAddress"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="form.countryBill == 'ID'">
                  <b-form-group label="Province *">
                    <template #label>
                      <div>
                        Province
                        <span class="text-red">*</span>
                      </div>
                    </template>
                    <v-select
                      :options="
                        sameAsGeneralAddress
                          ? option.provience
                          : optionBill.provience
                      "
                      required
                      label="name"
                      :reduce="(val) => val.id"
                      plain
                      v-model="form.provinceBill"
                      @input="onProvinceChangeBill"
                      placeholder="Select Province"
                      :disabled="sameAsGeneralAddress"
                    ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <template v-if="form.countryBill == 'ID'">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="City *">
                      <template #label>
                        <div>
                          City
                          <span class="text-red">*</span>
                        </div>
                      </template>
                      <v-select
                        label="name"
                        :reduce="(val) => val.id"
                        :options="
                          sameAsGeneralAddress
                            ? option.cities
                            : optionBill.cities
                        "
                        required
                        v-model="form.cityBill"
                        @input="onCityChangeBill"
                        placeholder="Select City"
                        :disabled="sameAsGeneralAddress || !form.provinceBill"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="District *">
                      <template #label>
                        <div>
                          District
                          <span class="text-red">*</span>
                        </div>
                      </template>
                      <v-select
                        label="name"
                        :reduce="(val) => val.id"
                        v-model="form.districtBill"
                        required
                        :options="
                          sameAsGeneralAddress
                            ? option.districts
                            : optionBill.districts
                        "
                        @input="onDistrictChangeBill"
                        placeholder="Select District"
                        :disabled="sameAsGeneralAddress || !form.cityBill"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="6">
                    <b-form-group label="Sub District">
                      <v-select
                        label="name"
                        :reduce="(val) => val.id"
                        v-model="form.subDistrictBill"
                        :options="
                          sameAsGeneralAddress
                            ? option.villages
                            : optionBill.villages
                        "
                        placeholder="Select Sub District"
                        :disabled="sameAsGeneralAddress || !form.districtBill"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Postal Code">
                      <b-form-input
                        type="number"
                        v-model="form.postalCodeBill"
                        placeholder="Enter Postal Code"
                        :disabled="sameAsGeneralAddress"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>

              <b-form-group label="Address">
                <b-form-textarea
                  v-model="form.addressBill"
                  rows="2"
                  :disabled="sameAsGeneralAddress"
                ></b-form-textarea>
              </b-form-group>

              <!-- Info when same as general address is enabled -->
              <b-alert
                v-if="sameAsGeneralAddress"
                show
                variant="info"
                class="mt-3 d-flex align-items-center"
              >
                <i class="fas fa-info-circle mr-2"></i>
                Billing address is automatically synced with general address
              </b-alert>
            </div>
          </section>
        </b-col>
        <b-col md="6">
          <!-- Bill To Info -->
          <section class="mb-4">
            <div class="section-title">
              <h6>BILL TO INFO</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Account Name">
                  <b-form-input v-model="form.accountNameBill"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Attention">
                  <b-form-input v-model="form.attention"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Bussiness">
                  <b-form-input v-model="form.bussiness1"></b-form-input>
                </b-form-group>
              </b-col>
              <!-- <b-col md="6">
                <b-form-group label="Bussiness 2">
                  <b-form-input v-model="form.bussiness2"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Bussiness 3">
                  <b-form-input v-model="form.bussiness3"></b-form-input>
                </b-form-group>
              </b-col> -->
              <b-col md="6">
                <b-form-group label="Fax">
                  <b-form-input
                    v-model="form.faxBill"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!-- <b-col md="6">
                <b-form-group label="Home">
                  <b-form-input v-model="form.homeBill"></b-form-input>
                </b-form-group>
              </b-col> -->
              <!-- <b-col md="6">
                <b-form-group label="Home Fax">
                  <b-form-input
                    type="number"
                    v-model="form.homeFax"
                  ></b-form-input>
                </b-form-group>
              </b-col> -->
              <b-col md="6">
                <b-form-group label="Email">
                  <b-form-input
                    v-model="form.emailBill"
                    type="email"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Web">
                  <b-form-input v-model="form.webBill"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
          <section class="mb-4">
            <div class="section-title">
              <h6>BANK ACCOUNT</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Beneficiary">
                  <b-form-input v-model="form.bankAccountName"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Bank Name">
                  <b-form-input v-model="form.bankName"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Bank Account">
                  <b-form-input
                    v-model="form.bankAccountNumber"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
        </b-col>
      </b-row>

      <div v-show="activeTab == 'contact'">
        <FormCustomerListContact
          :contacts="contacts"
          @update:contacts="contacts = $event"
          @deleteBulk="deleteBulkContact"
        />
      </div>
      <div v-show="activeTab == 'document'">
        <FormCustomerDocument
          :documents="documents"
          @update:documents="documents = $event"
          @deleteBulk="deleteBulkDocument"
        />
      </div>

      <!-- Buttons -->
      <b-row v-if="!isFormShippment" class="mt-4">
        <b-col cols="6">
          <b-button
            variant="outline-primary"
            class="w-100"
            @click="$emit('close')"
          >
            Cancel & Close
          </b-button>
        </b-col>
        <b-col cols="6">
          <b-button type="submit" variant="primary" class="w-100">
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import FormCustomerListContact from './FormCustomerListContact.vue'
import FormCustomerDocument from './FormCustomerDocument.vue'
import CustomNav from '@/src/components/global/CustomNav.vue'
import hmacClient from '@/src/services/hmacClient'
import { crewingActions, busdevActions } from '@/src/Utils/helper'

export default {
  name: 'FormCustomerNew',
  components: {
    FormCustomerListContact,
    FormCustomerDocument,
    CustomNav,
  },
  props: {
    value: { type: Object, default: null },
    isFormShippment: { type: Boolean, default: false },
  },
  data() {
    return {
      tabs: [
        { label: 'General', value: 'general' },
        { label: 'Billing', value: 'billing' },
        { label: 'Contact', value: 'contact' },
        { label: 'Support Document', value: 'document' },
      ],
      activeTab: 'general',
      form: {
        accountName: '',
        cutomerClass: '',
        cutomerStatus: 'Requested',
        country: 'ID',
        province: '',
        city: '',
        district: '',
        subDistrict: '',
        postalCode: '',
        address: '',
        countryBill: '',
        provinceBill: '',
        cityBill: '',
        districtBill: '',
        subDistrictBill: '',
        postalCodeBill: '',
        addressBill: '',
        logo: null,
        web: '',
        fax: '',
        assistance: '',
        picName: '',
        picJobTitle: '',
        emailOffice: '',
        email: '',
        phone: '',
        mobile: '',
        attention: '',
        bussiness1: '',
        bussiness2: '',
        bussiness3: '',
        faxBill: '',
        homeBill: '',
        homeFax: '',
        emailBill: '',
        webBill: '',
        accountNameBill: ''
      },
      cutomerClassOptions: ['Purchasing', 'Supplier', 'Contractor', 'Busdev'],
      cutomerCategoryOptions: ['Local', 'International'],
      cutomerStatusOptions: ['Active', 'Requested', 'Blacklist'],
      countryOptions: [],
      currencyOptions: ['IDR', 'USD', 'EUR'],
      bankOptions: ['Bank BCA', 'Bank Mandiri', 'Bank BNI'],
      contacts: [],
      option: {
        provience: [],
        cities: [],
        districts: [],
        villages: [],
        postalCodes: [],
      },
      optionBill: {
        provience: [],
        cities: [],
        districts: [],
        villages: [],
        postalCodes: [],
      },
      fields: [
        { key: 'selected', label: '', thStyle: { width: '40px' } },
        { key: 'name', label: 'Name' },
        { key: 'department', label: 'Department' },
        { key: 'job_title', label: 'Job Title' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'mobile_phone', label: 'Mobile Phone' },
        { key: 'actions', label: '', thStyle: { width: '40px' } },
      ],
      selectAll: false,
      documents: [],
      sameAsGeneralAddress: false,
    }
  },
  watch: {
    // Cascading dropdown watchers
    'form.province'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onProvinceChange(newValue)
      }
    },
    'form.city'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onCityChange(newValue)
      }
    },
    'form.district'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onDistrictChange(newValue)
      }
    },

    // Billing cascading dropdown watchers
    'form.provinceBill'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onProvinceChangeBill(newValue)
      }
    },
    'form.cityBill'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onCityChangeBill(newValue)
      }
    },
    'form.districtBill'(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.onDistrictChangeBill(newValue)
      }
    },

    // Watch for changes in general address when toggle is on
    'form.country'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue) {
        this.form.countryBill = newValue
        if (newValue === 'ID' && this.form.province) {
          this.copyGeneralToBilling()
        }
      }
    },
    'form.province'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue && newValue) {
        this.form.provinceBill = newValue
        this.onProvinceChange(newValue) // Update general options
      }
    },
    'form.city'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue && newValue) {
        this.form.cityBill = newValue
        this.onCityChange(newValue) // Update general options
      }
    },
    'form.district'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue && newValue) {
        this.form.districtBill = newValue
        this.onDistrictChange(newValue) // Update general options
      }
    },
    'form.subDistrict'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue) {
        this.form.subDistrictBill = newValue
      }
    },
    'form.postalCode'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue) {
        this.form.postalCodeBill = newValue
      }
    },
    'form.address'(newValue, oldValue) {
      if (this.sameAsGeneralAddress && newValue !== oldValue) {
        this.form.addressBill = newValue
      }
    },

    // When editing, prefill basic fields from value if provided
    value: {
      immediate: true,
      handler(v) {
        if (!v) return
        // Normalize possible nested shapes: account, billings[], contacts[], documents[]
        const acc = v.account || v
        const billing = (v.billings && v.billings[0]) || v.billing || {}
        const contacts = v.contacts || v.contact || []
        const documents = v.documents || v.files || []

        // Account info
        this.form.accountName =
          acc.account_name ||
          acc.accountName ||
          acc.name ||
          this.form.accountName
        this.form.cutomerStatus = acc.customer_status || this.form.cutomerStatus
        this.form.cutomerClass = acc.customer_class || this.form.cutomerClass
        this.form.web = acc.web || this.form.web
        this.form.fax = acc.fax || this.form.fax
        this.form.assistance = acc.assistance || this.form.assistance

        // Account address
        this.form.country = acc.country || acc.country_id || this.form.country
        this.form.province = acc.province || this.form.province
        this.form.city = acc.city || this.form.city
        this.form.district = acc.district || this.form.district
        this.form.subDistrict =
          acc.sub_district || acc.subDistrict || this.form.subDistrict
        this.form.postalCode =
          acc.postal_code || acc.postalCode || this.form.postalCode
        this.form.address = acc.address || this.form.address

        // Additional contact
        this.form.picName =
          acc.primary_name || acc.pic_name || this.form.picName
        this.form.picJobTitle =
          acc.primary_job_title || acc.pic_job_title || this.form.picJobTitle
        this.form.emailOffice =
          acc.primary_email_office || this.form.emailOffice
        this.form.email = acc.primary_email || acc.email || this.form.email
        this.form.phone = acc.primary_phone || acc.phone || this.form.phone
        this.form.mobile =
          acc.primary_mobile_phone || acc.mobile_phone || this.form.mobile

        // Billing address/info
        this.form.countryBill = billing.bill_country || this.form.countryBill
        this.form.provinceBill = billing.bill_province || this.form.provinceBill
        this.form.cityBill = billing.bill_city || this.form.cityBill
        this.form.districtBill = billing.bill_district || this.form.districtBill
        this.form.subDistrictBill =
          billing.bill_sub_district || this.form.subDistrictBill
        this.form.postalCodeBill =
          billing.bill_postal_code || this.form.postalCodeBill
        this.form.addressBill = billing.bill_address || this.form.addressBill
        this.form.attention = billing.attention || this.form.attention
        this.form.bussiness1 = billing.business_1 || this.form.bussiness1
        this.form.bussiness2 = billing.business_2 || this.form.bussiness2
        this.form.bussiness3 = billing.business_3 || this.form.bussiness3
        this.form.faxBill = billing.fax || this.form.faxBill
        this.form.homeBill = billing.home || this.form.homeBill
        this.form.homeFax = billing.home_fax || this.form.homeFax
        this.form.emailBill = billing.email || this.form.emailBill
        this.form.webBill = billing.web || this.form.webBill

        // Contacts
        if (Array.isArray(contacts) && contacts.length) {
          this.contacts = contacts.map((c) => ({
            selected: !!c.selected,
            name: c.name || '',
            department: c.department || '',
            job_title: c.job_title || c.jobTitle || '',
            email: c.email || '',
            phone: c.phone || '',
            mobile_phone: c.mobile_phone || c.mobile || '',
            title: c.title || ''
          }))
        }

        // Documents
        if (Array.isArray(documents) && documents.length) {
          this.documents = documents.map((d) => ({
            selected: !!d.selected,
            document_name: d.document_name || d.name || '',
            fileName: d.fileName || d.document_name || d.name || '',
            file_path: d.file_path || '',
            is_required: d.is_required === true,
          }))
        }
      },
    },
  },
  methods: {
    ...crewingActions,
    ...busdevActions,

    findIdByName(option, value) {
      const found = option.find((opt) => opt.name === value)
      return found ? found.id : null
    },

    async fetchProvinsi() {
      this._loading = true
      let res = await this.fetchProvience()

      if (res.status) {
        if (res.data && res.data.length > 0) {
          res.data.map((state) => {
            this.option.provience.push({
              id: state.id,
              name: state.name,
            })
          })
        }
      }
    },

    async fetchProvinsiBill() {
      let res = await this.fetchProvience()

      if (res.status) {
        if (res.data && res.data.length > 0) {
          res.data.map((state) => {
            this.optionBill.provience.push({
              id: state.id,
              name: state.name,
            })
          })
        }
      }
    },

    async fetchKota(name) {
      let method = 'fetchCities'
      const id = this.findIdByName(this.option.provience, name)
      const { data } = await this[method]({ id: id })

      this.option.cities = []
      this.option.districts = []
      this.option.villages = []
      this.option.postalCodes = []

      for (const property in data) {
        this.option.cities.push({
          id: property,
          name: data[property],
        })
      }

      this.loadingKota = false
    },

    async onProvinceChange(provinceId) {
      if (!provinceId) {
        this.form.city = ''
        this.form.district = ''
        this.form.subDistrict = ''
        this.form.postalCode = ''
        this.option.cities = []
        this.option.districts = []
        this.option.villages = []
        this.option.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchCities({ id: provinceId })

        this.option.cities = []
        this.option.districts = []
        this.option.villages = []
        this.option.postalCodes = []

        // Clear dependent fields
        this.form.city = ''
        this.form.district = ''
        this.form.subDistrict = ''
        this.form.postalCode = ''

        for (const property in data) {
          this.option.cities.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching cities:', error)
      }
    },

    async onCityChange(cityId) {
      if (!cityId) {
        this.form.district = ''
        this.form.subDistrict = ''
        this.form.postalCode = ''
        this.option.districts = []
        this.option.villages = []
        this.option.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchDistricts({ id: cityId })

        this.option.districts = []
        this.option.villages = []
        this.option.postalCodes = []

        // Clear dependent fields
        this.form.district = ''
        this.form.subDistrict = ''
        this.form.postalCode = ''

        for (const property in data) {
          this.option.districts.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching districts:', error)
      }
    },

    async onDistrictChange(districtId) {
      if (!districtId) {
        this.form.subDistrict = ''
        this.form.postalCode = ''
        this.option.villages = []
        this.option.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchVillages({ id: districtId })

        this.option.villages = []
        this.option.postalCodes = []

        // Clear dependent fields
        this.form.subDistrict = ''
        this.form.postalCode = ''

        for (const property in data) {
          this.option.villages.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching villages:', error)
      }
    },

    // Billing address cascading methods
    async onProvinceChangeBill(provinceId) {
      // If same as general address, don't update billing-specific options
      if (this.sameAsGeneralAddress) {
        return
      }

      if (!provinceId) {
        this.form.cityBill = ''
        this.form.districtBill = ''
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''
        this.optionBill.cities = []
        this.optionBill.districts = []
        this.optionBill.villages = []
        this.optionBill.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchCities({ id: provinceId })

        this.optionBill.cities = []
        this.optionBill.districts = []
        this.optionBill.villages = []
        this.optionBill.postalCodes = []

        // Clear dependent fields
        this.form.cityBill = ''
        this.form.districtBill = ''
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''

        for (const property in data) {
          this.optionBill.cities.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching cities for billing:', error)
      }
    },

    async onCityChangeBill(cityId) {
      // If same as general address, don't update billing-specific options
      if (this.sameAsGeneralAddress) {
        return
      }

      if (!cityId) {
        this.form.districtBill = ''
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''
        this.optionBill.districts = []
        this.optionBill.villages = []
        this.optionBill.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchDistricts({ id: cityId })

        this.optionBill.districts = []
        this.optionBill.villages = []
        this.optionBill.postalCodes = []

        // Clear dependent fields
        this.form.districtBill = ''
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''

        for (const property in data) {
          this.optionBill.districts.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching districts for billing:', error)
      }
    },

    async onDistrictChangeBill(districtId) {
      // If same as general address, don't update billing-specific options
      if (this.sameAsGeneralAddress) {
        return
      }

      if (!districtId) {
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''
        this.optionBill.villages = []
        this.optionBill.postalCodes = []
        return
      }

      try {
        const { data } = await this.fetchVillages({ id: districtId })

        this.optionBill.villages = []
        this.optionBill.postalCodes = []

        // Clear dependent fields
        this.form.subDistrictBill = ''
        this.form.postalCodeBill = ''

        for (const property in data) {
          this.optionBill.villages.push({
            id: property,
            name: data[property],
          })
        }
      } catch (error) {
        console.error('Error fetching villages for billing:', error)
      }
    },

    // Helper methods for toggle functionality
    onSameAsGeneralChange(checked) {
      if (checked) {
        // Copy general address to billing address
        this.copyGeneralToBilling()
      }
      // Note: We don't clear billing address when unchecked anymore
      // User can manually modify billing address when toggle is off
    },

    async copyGeneralToBilling() {
      try {
        // Copy basic fields
        this.form.countryBill = this.form.country
        this.form.addressBill = this.form.address

        // If Indonesia, copy location data directly (no need to reload since we use same options)
        if (this.form.country === 'ID') {
          this.form.provinceBill = this.form.province
          this.form.cityBill = this.form.city
          this.form.districtBill = this.form.district
          this.form.subDistrictBill = this.form.subDistrict
          this.form.postalCodeBill = this.form.postalCode
        }
      } catch (error) {
        console.error('Error copying general address to billing:', error)
      }
    },

    clearBillingAddress() {
      this.form.countryBill = ''
      this.form.provinceBill = ''
      this.form.cityBill = ''
      this.form.districtBill = ''
      this.form.subDistrictBill = ''
      this.form.postalCodeBill = ''
      this.form.addressBill = ''

      // Clear billing options
      this.optionBill.cities = []
      this.optionBill.districts = []
      this.optionBill.villages = []
      this.optionBill.postalCodes = []
    },

    getLocationName(options, id) {
      const found = options.find((option) => option.id === id)
      return found ? found.name : ''
    },

    getCountryName(countryCode) {
      const found = this.countryOptions.find(
        (country) => country.value === countryCode
      )
      return found ? found.text : countryCode
    },

    async fetchKecamatan(name) {
      let method = 'fetchDistricts'

      const id = this.findIdByName(this.option.cities, name)
      const { data } = await this[method]({ id: id })

      this.option.districts = []
      this.option.villages = []

      for (const property in data) {
        this.option.districts.push({
          id: property,
          name: data[property],
        })
      }
    },

    async fetchKelurahan(name) {
      let method = 'fetchVillages'

      const id = this.findIdByName(this.option.districts, name)
      const { data } = await this[method]({ id: id })

      this.option.villages = []
      for (const property in data) {
        this.option.villages.push({
          id: property,
          name: data[property],
        })
      }
    },

    deleteBulkDocument() {
      this.documents = this.documents.filter((d) => !d.selected)
    },
    deleteBulkContact() {
      this.contacts = this.contacts.filter((c) => !c.selected)
    },
    async fetchCountries() {
      try {
        const response = await fetch(
          'https://restcountries.com/v3.1/all?fields=name,cca2'
        )
        const countries = await response.json()

        this.countryOptions = countries
          .map((country) => ({
            value: country.cca2,
            text: `${country.name.common} (${country.cca2})`,
          }))
          .sort((a, b) => a.text.localeCompare(b.text))
        this.countryOptions.unshift({ value: '', text: 'Select Country' })
      } catch (error) {
        console.error('Failed to fetch countries:', error)
        // Fallback to some basic countries if API fails
        // this.countryOptions = [
        //   { value: '', text: 'Select Country' },
        //   { value: 'ID', text: 'Indonesia (ID)' },
        //   { value: 'MY', text: 'Malaysia (MY)' },
        //   { value: 'SG', text: 'Singapore (SG)' },
        //   { value: 'US', text: 'United States (US)' },
        //   { value: 'GB', text: 'United Kingdom (GB)' },
        // ]
      }
    },
    async onSubmit() {
      try {
        this.$emit('loading', true)

        // Helper function to get name by ID from options
        const getNameById = (options, id) => {
          const found = options.find((option) => option.id === id)
          return found ? found.name : ''
        }

        // Upload supporting documents first (if any files are attached)
        let resUploadDocuments = { data: [] }
        try {
          const filesToUpload = (this.documents || [])
            .map((d, idx) => ({ idx, file: d.file_path || null }))
            .filter((x) => x.file)

          if (filesToUpload.length > 0) {
            const formData = new FormData()
            filesToUpload.forEach(({ file }) => {
              formData.append('files', file)
            })

            resUploadDocuments = await hmacClient.post(`/upload/files?maxSizeMb=25`, {
              data: formData,
              headers: { 'Content-Type': 'multipart/form-data' },
            })

            // Map uploaded URLs/paths back to documents order
            const uploaded = resUploadDocuments?.data?.files

            let uploadIndex = 0
            this.documents = (this.documents || []).map((doc) => {
              if (doc.file_path) {
                const info = uploaded[uploadIndex++] || null
                console.log(info, uploaded[uploadIndex++], 'INFOO')
                return {
                  ...doc,
                  file_path: info || '',
                  fileName:
                    doc.fileName || info.originalname || info.filename || doc.document_name || doc.name || '',
                }
              }
              return doc
            })
          }
        } catch (e) {
          // If upload fails, surface error and stop submit
          throw e
        }

        const payload = {
          account: {
            account_name: this.form.accountName,
            customer_status: this.form.cutomerStatus,
            customer_class: this.form.cutomerClass,
            logo_path: '',
            web: this.form.web,
            fax: this.form.fax,
            assistance: this.form.assistance,
            primary_name: this.form.picName,
            primary_job_title: this.form.picJobTitle,
            primary_email_office: this.form.emailOffice,
            primary_email: this.form.email,
            primary_phone: this.form.phone,
            primary_mobile_phone: this.form.mobile,
            country: this.getCountryName(this.form.country),
            province: getNameById(this.option.provience, this.form.province),
            city: getNameById(this.option.cities, this.form.city),
            district: getNameById(this.option.districts, this.form.district),
            sub_district_id: this.form.subDistrict,
            sub_district: getNameById(
              this.option.villages,
              this.form.subDistrict
            ),
            postal_code_id: this.form.postalCode,
            postal_code: this.form.postalCode,
            address: this.form.address,
          },
          billings: [
            {
              bill_country: this.getCountryName(this.form.countryBill),
              bill_province: this.sameAsGeneralAddress
                ? getNameById(this.option.provience, this.form.provinceBill)
                : getNameById(
                    this.optionBill.provience,
                    this.form.provinceBill
                  ),
              bill_city: this.sameAsGeneralAddress
                ? getNameById(this.option.cities, this.form.cityBill)
                : getNameById(this.optionBill.cities, this.form.cityBill),
              bill_district: this.sameAsGeneralAddress
                ? getNameById(this.option.districts, this.form.districtBill)
                : getNameById(
                    this.optionBill.districts,
                    this.form.districtBill
                  ),
              bill_sub_district: this.sameAsGeneralAddress
                ? getNameById(this.option.villages, this.form.subDistrictBill)
                : getNameById(
                    this.optionBill.villages,
                    this.form.subDistrictBill
                  ),
              bill_postal_code: this.form.postalCodeBill,
              bill_address: this.form.addressBill,
              attention: this.form.attention,
              business_1: this.form.bussiness1,
              business_2: this.form.bussiness2,
              business_3: this.form.bussiness3,
              fax: this.form.faxBill,
              home: this.form.homeBill,
              home_fax: this.form.homeFax,
              email: this.form.emailBill,
              web: this.form.webBill,
              bank_account_name: this.form.bankAccountName,
              bank_name: this.form.bankName,
              bank_account_number: this.form.bankAccountNumber,
            },
          ],
          contacts: this.contacts.map((c) => ({
            name: c.name,
            department: c.department,
            job_title: c.job_title || c.jobTitle || '',
            email: c.email,
            phone: c.phone,
            mobile_phone: c.mobile_phone || c.mobile || '',
            title: c.title,
          })),
          documents: (this.documents || []).map((d) => ({
            document_name: d.document_name || d.name || null,
            file_path: d.file_path || '',
            is_required: d.is_required === true,
          })),
        }

        // Map fields if backend expects different keys; adjust as needed
        // Decide create or update based on passed `value` prop (contains id)
        let res
        if (this.value && (this.value.id || this.value._id)) {
          const id = this.value.id || this.value._id
          res = await hmacClient.put(`/busdev/customer-prospects/${id}`, {
            data: payload,
          })
        } else {
          res = await hmacClient.post('/busdev/customer-prospects', {
            data: payload,
          })
        }

        this.$swal.fire(
          'Success',
          'Customer form submitted successfully',
          'success'
        )        
        this.$emit('submitted', res?.data)
        this.$emit('close')
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          'Failed to submit form'
        this.$swal
          ? this.$swal({ title: 'Submit Failed', text: msg, icon: 'error' })
          : this.$bvToast?.toast(msg, {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
      } finally {
        this.$emit('loading', false)
      }
    },
    onWebChange() {
      if (this.form.web) {
        this.form.webBill = this.form.web
      }
    },
  },
  mounted() {
    this.fetchCountries()
    this.fetchProvinsi()
    this.fetchProvinsiBill()
  },
}
</script>

<style scoped>
.section-title {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #334697;
  background: blue;
  margin-bottom: 20px;
}

.section-title h6 {
  color: #273469;
  font-weight: 600;
  background: white;
  position: absolute;
  top: -12px;
  padding-right: 20px;
}

.custom-checkbox {
  font-size: 14px;
}

.custom-checkbox label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.copied-address-display {
  margin-top: 10px;
}

.address-preview {
  border: 1px solid #dee2e6;
  font-size: 14px;
  line-height: 1.5;
}

.address-preview .text-muted {
  font-weight: 500;
  margin-right: 8px;
}
</style>
